/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Alerts/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Alert from './Alert/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Alerts({
  children,
  viewPath = "/App/Account/PatientNotifications/Content/Content/Content/Alerts"
  
}) {
let notificationsValueData = fromData.useDataValue({ viewPath,
context: 'notifications',
})
  return (<React.Fragment
>
<div
  data-testid="Alerts.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(notificationsValueData) && notificationsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="alert"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Alert(${item?.id ?? item?._id ?? index})`}
      >
<Alert
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Alert(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }